import React from 'react';

import axios from 'axios'
import { Table, Input, Button,Collapse,Typography,DatePicker,Space,Divider,Popover,Popconfirm,message,Descriptions,Modal,Spin,Tabs,Form,Switch } from 'antd';
import Highlighter from 'react-highlight-words';
import Icon from '@ant-design/icons';
import { SearchOutlined,DeleteOutlined,DownloadOutlined,PrinterOutlined,FundViewOutlined,EditOutlined,WalletFilled,LoadingOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import CurrencyFormat from 'react-currency-format';
import * as serverconfig from '../serverconn'
import ReactToPrint from 'react-to-print';
import * as reactstrp from 'reactstrap';
import moment from 'moment';

import {
  Col,
  Row,
} from 'reactstrap';
import ReactExport from "@ibrahimrahmani/react-export-excel";
import '../tablestyle.css'; // Create this CSS file for custom styles

var CryptoJS = require("crypto-js");
const dateFormat = 'DD/MM/YYYY';
const FormItem=Form.Item;


const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const { Panel } = Collapse;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;
const { Title } = Typography;
const { TabPane } = Tabs;

function callback(key) {
  console.log(key);
}

var token= ''
var sacco= ''
var bizuserid= ''

class ReportToPrint extends React.Component {

  state = {
    companyprofile:{},
  };

  componentDidMount(){

    if(localStorage.getItem("sacco")){
       sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
       bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
    }else{
       sacco= ''
       bizuserid= ''
    }
    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }

    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    axios.get(`${serverconfig.backendserverurl}/api/saccos/${sacco}`)
    .then(res => {  
        this.setState({
          companyprofile: res.data
        })

    })

    }

        //calculate total savings
        calculateTotalSavings=()=>{
          var Total=0
          this.props.members.map(
            (item)=>{
              Total+=Number(item.savings_balance)
            })
      
          return Total.toFixed(2);

        }

        calculateTotalSavingsInterest=()=>{
          var Total=0
          this.props.members.map(
            (item)=>{
              Total+=Number(item.saving_interestbalance)
            })
      
          return Total.toFixed(2);

        }



        //calculate total shares number
        calculateTotalShares_number=()=>{
          var Total=0
          this.props.members.map(
            (item)=>{
              Total+=Number(item.sharesnumber_balance)
            })
      
          return Total.toFixed(2);
    
        }

          //calculate total shares number
          calculateTotalShares_amount=()=>{
            var Total=0
            this.props.members.map(
              (item)=>{
                Total+=Number(item.sharesamount_balance)
              })
        
            return Total.toFixed(2);
      
          }
        

          calculateTotal_loanamount=()=>{
            var Total=0
            this.props.members.map(
              (item)=>{
                Total+=Number(item.loan_balance)
              })
        
            return Total.toFixed(2);
          }

          calculateTotal_loaninterestamount=()=>{
            var Total=0
            this.props.members.map(
              (item)=>{
                Total+=Number(item.saving_interestbalance)
              })
        
            return Total.toFixed(2);
          }

          calculateTotal_loanfineamount=()=>{
            var Total=0
            this.props.members.map(
              (item)=>{
                Total+=Number(item.loanfine_balance)
              })
        
            return Total.toFixed(2);
          }


          //new
          calculateTotal_loansavingssecurity=()=>{
            var Total=0
            this.props.members.map(
              (item)=>{
                Total+=Number(item.savingsloan_security_balance)
              })
            return Total.toFixed(2);
      
          }


          calculateTotal_fixeddeposit=()=>{
            var Total=0
            this.props.members.map(
              (item)=>{
                Total+=Number(item.fixed_deposit_balance)
              })
            return Total.toFixed(2);
      
          }



          calculateTotal_accumulated_dividendsbalance=()=>{
            var Total=0
            this.props.members.map(
              (item)=>{
                Total+=Number(item.accumulated_dividendsbalance)
              })
            return Total.toFixed(2);
      
          }


  render() {
    return (
      <div style={{padding:20}}>
<Row> 
              <Col xs="2" sm="2" lg="2">
              <img height="100" width="120"  alt="Logo" src={this.state.companyprofile.sacco_logo} />
            
                </Col>
                <Col xs="6" sm="6" lg="6">
                <h3>{this.state.companyprofile.sacco_name}</h3>
                <h6>Tel: {this.state.companyprofile.RegisteredPhoneNumber1}
                {
                this.state.companyprofile.RegisteredPhoneNumber2==""?
                "":","+this.state.companyprofile.RegisteredPhoneNumber2
                }
              
                </h6>               
                <h5>Email: {this.state.companyprofile.company_email}</h5>
                <h5>Wesite: {this.state.companyprofile.website}</h5>
                <h5>{this.state.companyprofile.box_number}</h5>
              
                </Col>

     </Row>

           <h3 style={{display: 'flex',justifyContent:'center', alignItems:'center',fontWeight:'bolder'}}>MEMBER SUMMARY REPORT BY {this.props.date}</h3>

           <reactstrp.Table bordered >
                      <thead>
                        <tr>
                          <th>No</th>
                          <th>Account Number</th>
                          <th>Account Name</th>
                          <th>Account Contact</th>

                          <th>Member Type</th>
                          <th>Savings balance</th>
                          <th>Savings interest</th>
                          <th>Shares No</th>
                          <th>Shares Amount</th>
                          <th>Loan balance</th>
                          <th>Loan interest balance</th>
                          <th>Loan fine balance</th>
                          <th>Savings loan security (Reserve)</th>
                          <th>Fixed deposit</th>
                          <th>Accumulated dividends</th>

                        </tr>
                      </thead>
                      <tbody>

                      {this.props.members.map(
                        (item)=>(
                          <tr>
                          
                          <td>{item.no}</td>

                          <td>{item.AccountNumber}</td>
                          <td>{item.FullName}</td>
                          <td>{item.RegisteredPhoneNumber1}</td>

                          <td>{item.membertypename}</td>
                          
                          <td className="align-right">{<CurrencyFormat value={item.savings_balance} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td className="align-right">{<CurrencyFormat value={item.saving_interestbalance} displayType={'text'} thousandSeparator={true}/>}</td>

                          <td className="align-right">{item.sharesnumber_balance} </td>
                          <td className="align-right">{<CurrencyFormat value={item.sharesamount_balance} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td className="align-right">{<CurrencyFormat value={item.loan_balance} displayType={'text'} thousandSeparator={true}/>}</td>                         
                          <td className="align-right">{<CurrencyFormat value={item.loaninterest_balance} displayType={'text'} thousandSeparator={true}/>}</td>                         
                          <td className="align-right">{<CurrencyFormat value={item.loanfine_balance} displayType={'text'} thousandSeparator={true}/>}</td>                         
                          <td className="align-right">{<CurrencyFormat value={item.savingsloan_security_balance} displayType={'text'} thousandSeparator={true}/>}</td>                         
                          <td className="align-right">{<CurrencyFormat value={item.fixed_deposit_balance} displayType={'text'} thousandSeparator={true}/>}</td>                         
                          <td className="align-right">{<CurrencyFormat value={item.accumulated_dividendsbalance} displayType={'text'} thousandSeparator={true}/>}</td>                         

                          </tr>
                        ))}
                        <tr>
                        <td style={{fontWeight:'bolder'}}>Total</td>
                        <td></td>
                        <td></td>
                        <td></td>

                        <td></td>
                        <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotalSavings()} displayType={'text'} thousandSeparator={true}/>}</td>
                        <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotalSavingsInterest()} displayType={'text'} thousandSeparator={true}/>}</td>

                        <td className="align-right"style={{fontWeight:'bolder'}}>{this.calculateTotalShares_number()}</td>
                        <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotalShares_amount()} displayType={'text'} thousandSeparator={true}/>}</td>
                        <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotal_loanamount()} displayType={'text'} thousandSeparator={true}/>}</td>
                        
                        <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotal_loaninterestamount()} displayType={'text'} thousandSeparator={true}/>}</td>
                        <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotal_loanfineamount()} displayType={'text'} thousandSeparator={true}/>}</td>
                        <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotal_loansavingssecurity()} displayType={'text'} thousandSeparator={true}/>}</td>
                        <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotal_fixeddeposit()} displayType={'text'} thousandSeparator={true}/>}</td>
                        <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotal_accumulated_dividendsbalance()} displayType={'text'} thousandSeparator={true}/>}</td>

                        </tr>

                    </tbody>
                </reactstrp.Table> 
                <br></br>
                <h3>Generated by: {CryptoJS.AES.decrypt(localStorage.getItem("username") , 'my-secret-key@123').toString(CryptoJS.enc.Utf8)}</h3>
                <h3>Powered by: www.pitech.co.ug</h3>   
           
      </div>
    );
  }
}


class MemberSavingsReport extends React.Component {
  state = {
    searchText: '',
    searchedColumn: '',
    members: [],
    viewpaymentmodal:false,
    expensedetails:{},
    companyprofile:{},
    userprofile:{},
    datarequested:true,
    memberactivationformvisible:false,
    selectedmemberid:'',
    shareholder_members: [],
    date:moment().format(dateFormat).toString(),
    email_report:false,
    receiving_email:''

  };

  componentDidMount(){
      if(localStorage.getItem("sacco")){
        sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
        bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
    }else{
        sacco= ''
        bizuserid= ''
    }
    
    if(localStorage.getItem("token")){
        token= localStorage.getItem("token")
    }else{
        token= ''
    }

    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    axios.get(`${serverconfig.backendserverurl}/api/saccos/${sacco}`)
    .then(res => {  
        this.setState({
          companyprofile: res.data
        })

    })

   {/* axios.get(serverconfig.backendserverurl+`/api/members_dataview/?sacco=${sacco}`)
    .then(res => {
        this.setState({
          members:res.data
        })

        //this.setState({datarequested:false})


    }) */}

    /*
    let form_data1 = new FormData();
    form_data1.append('sacco', sacco);
    form_data1.append('date', this.state.date);
    axios.post(serverconfig.backendserverurl+`/customqueries/getMembersummaryreport_byperiod`, form_data1)
    .then(res => {
      this.setState({members:JSON.parse(res.data.members_report)})

    }) */

    this.setState({datarequested:false})


}

        //calculate total savings
        calculateTotalSavings=()=>{
          var Total=0
          this.state.members.map(
            (item)=>{
              Total+=Number(item.savings_balance)
            })
      
          return Total.toFixed(2);

        }

        calculateTotalSavingsInterest=()=>{
          var Total=0
          this.state.members.map(
            (item)=>{
              Total+=Number(item.saving_interestbalance)
            })
      
          return Total.toFixed(2);

        }


        //calculate total shares number
        calculateTotalShares_number=()=>{
          var Total=0
          this.state.members.map(
            (item)=>{
              Total+=Number(item.sharesnumber_balance)
            })
      
          return Total.toFixed(2);
    
        }

          //calculate total shares number
          calculateTotalShares_amount=()=>{
            var Total=0
            this.state.members.map(
              (item)=>{
                Total+=Number(item.sharesamount_balance)
              })
        
            return Total.toFixed(2);
      
          }
        

          calculateTotal_loanamount=()=>{
            var Total=0
            this.state.members.map(
              (item)=>{
                Total+=Number(item.loan_balance)
              })
        
            return Total.toFixed(2);
          }

          calculateTotal_loaninterestamount=()=>{
            var Total=0
            this.state.members.map(
              (item)=>{
                Total+=Number(item.loaninterest_balance)
              })
        
            return Total.toFixed(2);
          }

          calculateTotal_loanfineamount=()=>{
            var Total=0
            this.state.members.map(
              (item)=>{
                Total+=Number(item.loanfine_balance)
              })
        
            return Total.toFixed(2);
          }


          //new
          calculateTotal_loansavingssecurity=()=>{
            var Total=0
            this.state.members.map(
              (item)=>{
                Total+=Number(item.savingsloan_security_balance)
              })
            return Total.toFixed(2);
      
          }


          calculateTotal_fixeddeposit=()=>{
            var Total=0
            this.state.members.map(
              (item)=>{
                Total+=Number(item.fixed_deposit_balance)
              })
            return Total.toFixed(2);
      
          }


          calculateTotal_accumulated_dividendsbalance=()=>{
            var Total=0
            this.state.members.map(
              (item)=>{
                Total+=Number(item.accumulated_dividendsbalance)
              })
            return Total.toFixed(2);
      
          }


getColumnSearchProps = dataIndex => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }}>
      <Input
        ref={node => {
          this.searchInput = node;
        }}
        placeholder={`Search ${dataIndex}`}
        value={selectedKeys[0]}
        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        style={{ width: 188, marginBottom: 8, display: 'block' }}
      />
      <Button
        type="primary"
        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        icon={<SearchOutlined />}
        size="small"
        style={{ width: 90, marginRight: 8 }}
      >
        Search
      </Button>
      <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
        Reset
      </Button>
    </div>
  ),
  filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
  onFilter: (value, record) =>
    record[dataIndex]
      .toString()
      .toLowerCase()
      .includes(value.toLowerCase()),
  onFilterDropdownVisibleChange: visible => {
    if (visible) {
      setTimeout(() => this.searchInput.select());
    }
  },
  render: text =>
    this.state.searchedColumn === dataIndex ? (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text.toString()}
      />
    ) : (
      text
    ),
});


  render() {
    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
              <Spin size="large">
                <div className="content" />
              </Spin>          
             </div>
      )

    }else{
      return(
        <div>
            <div style={{display: "none"}}>
               &nbsp;&nbsp;
              <ReportToPrint
              totalsavings={this.calculateTotalSavings()} 
              members={this.state.members}
              date={this.state.date}
              ref={el => (this.componentRef = el)} /> 
             </div>

            <Collapse defaultActiveKey={['1']} onChange={this.callback}>
            <Panel header={<h4 style={{fontWeight:'bolder'}}> MEMBER BALANCES REPORT BY {this.state.date}</h4>} key="1">

            <div style={{display:'flex',justifyContent:'flex-start',alignSelf:'flex-start',alignItems:'flex-start'}}>

             <Form.Item label="EMail Report?">
                <Switch
                    checked={this.state.email_report}
                    onChange={val=>{this.setState({email_report:val})}}
                    checkedChildren="True"
                    unCheckedChildren="False"
                    />
              </Form.Item>
              &nbsp;&nbsp;

              {/**Check if emailing report */}

              {
                this.state.email_report===true?
                <div style={{display:'flex',flexDirection:'row'}}>
                 <FormItem label="Receiving email">
                  <Input name="receiving_email" 
                  placeholder="Receiving email."
                  value={this.state.receiving_email}
                  onChange={(val)=>{this.setState({receiving_email:val.target.value})}} />
                 </FormItem>
                </div>
                :
                <div style={{display:'flex',flexDirection:'row'}}>
                    <ReactToPrint
                        trigger={() => 
                        <Button type="primary"  shape="round" icon={<PrinterOutlined />} size={this.state.size}>
                        Print
                        </Button>
                        }
                        content={() => this.componentRef}
                        />
                    &nbsp;&nbsp;&nbsp;

                    <ExcelFile filename={"Pisacco - Member summary report by "+this.state.date} element={<Button type='primary' icon={<DownloadOutlined/>}>Download report</Button>}>
                      <ExcelSheet data={this.state.members} name="Member summary report">
                          <ExcelColumn label="No" value="no"/>

                          <ExcelColumn label="Acc No" value="AccountNumber"/>
                          <ExcelColumn label="Acc Name" value="FullName"/>
                          <ExcelColumn label="Acc Contact" value="RegisteredPhoneNumber1"/>

                          <ExcelColumn label="Member type" value="membertypename"/>
                          <ExcelColumn label="Savings" value="savings_balance"/>
                          <ExcelColumn label="Savings interest" value="saving_interestbalance"/>

                          <ExcelColumn label="Share no" value="sharesnumber_balance"/>
                          <ExcelColumn label="Share amount" value="sharesamount_balance"/>

                          <ExcelColumn label="Loan amount" value="loan_balance"/>
                          <ExcelColumn label="Loan interest" value="loaninterest_balance"/>
                          <ExcelColumn label="Loan fine" value="loanfine_balance"/>

                          <ExcelColumn label="Savings loan security (Reserve)" value="savingsloan_security_balance"/>
                          <ExcelColumn label="Fixed deposit" value="fixed_deposit_balance"/>
                          <ExcelColumn label="Accumulated dividendsbalance" value="accumulated_dividendsbalance"/>

                      </ExcelSheet>

                  </ExcelFile>

                </div>
              }


            &nbsp;&nbsp;&nbsp;

            <Form  layout="inline" >
            
            <FormItem label="Summary by (Date)">
                <DatePicker onChange={(date, dateString) =>{
                this.setState({ date: dateString});
              }} format={dateFormat} />
            </FormItem>


            <FormItem>
            <Button onClick={()=>{

            if(this.state.date==='' ){
              message.error("Date one missing")
            }else if (this.state.email_report===true && this.state.receiving_email===""){
              message.error("Please enter email")
            } else{
                this.setState({datarequested:true})

                let form_data1 = new FormData();
                form_data1.append('sacco', sacco);
                form_data1.append('date', this.state.date);
                
                form_data1.append('receiving_email', this.state.receiving_email);
                form_data1.append('email_report', this.state.email_report);

                axios.post(serverconfig.backendserverurl+`/customqueries/getMembersummaryreport_byperiod`, form_data1)
                .then(res => {
                  this.setState({members:JSON.parse(res.data.members_report)})
                  message.info(res.data.message)
                  this.setState({datarequested:false})

                })

            }

            }} type="primary" htmlType="button">
              {
                this.state.email_report?
                "Send Email"
                :
                "Search"
              }
              
                </Button>
            </FormItem> 
            </Form>


          </div>
          <br></br>

            <div style={{overflowX : 'auto'}}>

            <reactstrp.Table bordered >
                      <thead>
                        <tr>
                          <th>No</th>
                          <th>Account Number</th>
                          <th>Account Name</th>
                          <th>Account Contact</th>

                          <th>Member Type</th>
                          <th>Savings balance</th>
                          <th>Savings interest</th>
                          <th>Shares No</th>
                          <th>Shares Amount</th>
                          <th>Loan balance</th>
                          <th>Loan interest balance</th>
                          <th>Loan fine balance</th>
                          <th>Savings loan security (Reserve)</th>
                          <th>Fixed deposit</th>
                          <th>Accumulated dividends</th>

                        </tr>
                      </thead>
                      <tbody>

                      {this.state.members.map(
                        (item)=>(
                          <tr>
                          
                          <td>{item.no}</td>

                          <td>{item.AccountNumber}</td>
                          <td>{item.FullName}</td>
                          <td>{item.RegisteredPhoneNumber1}</td>

                          <td>{item.membertypename}</td>
                          
                          <td className="align-right">{<CurrencyFormat value={item.savings_balance} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td className="align-right">{<CurrencyFormat value={item.saving_interestbalance} displayType={'text'} thousandSeparator={true}/>}</td>

                          <td className="align-right">{item.sharesnumber_balance} </td>
                          <td className="align-right">{<CurrencyFormat value={item.sharesamount_balance} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td className="align-right">{<CurrencyFormat value={item.loan_balance} displayType={'text'} thousandSeparator={true}/>}</td>                         
                          <td className="align-right">{<CurrencyFormat value={item.loaninterest_balance} displayType={'text'} thousandSeparator={true}/>}</td>                         
                          <td className="align-right">{<CurrencyFormat value={item.loanfine_balance} displayType={'text'} thousandSeparator={true}/>}</td>                         
                          <td className="align-right">{<CurrencyFormat value={item.savingsloan_security_balance} displayType={'text'} thousandSeparator={true}/>}</td>                         
                          <td className="align-right">{<CurrencyFormat value={item.fixed_deposit_balance} displayType={'text'} thousandSeparator={true}/>}</td>                         
                          <td className="align-right">{<CurrencyFormat value={item.accumulated_dividendsbalance} displayType={'text'} thousandSeparator={true}/>}</td>                         

                          </tr>
                        ))}
                        <tr>
                        <td style={{fontWeight:'bolder'}}>Total</td>
                        <td></td>
                        <td></td>
                        <td></td>

                        <td></td>
                        <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotalSavings()} displayType={'text'} thousandSeparator={true}/>}</td>
                        <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotalSavingsInterest()} displayType={'text'} thousandSeparator={true}/>}</td>

                        <td className="align-right"style={{fontWeight:'bolder'}}>{this.calculateTotalShares_number()}</td>
                        <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotalShares_amount()} displayType={'text'} thousandSeparator={true}/>}</td>
                        <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotal_loanamount()} displayType={'text'} thousandSeparator={true}/>}</td>
                        
                        <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotal_loaninterestamount()} displayType={'text'} thousandSeparator={true}/>}</td>
                        <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotal_loanfineamount()} displayType={'text'} thousandSeparator={true}/>}</td>
                        <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotal_loansavingssecurity()} displayType={'text'} thousandSeparator={true}/>}</td>
                        <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotal_fixeddeposit()} displayType={'text'} thousandSeparator={true}/>}</td>
                        <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotal_accumulated_dividendsbalance()} displayType={'text'} thousandSeparator={true}/>}</td>

                        </tr>

                    </tbody>
                </reactstrp.Table>    
            </div>
       
        </Panel>
      </Collapse>


      </div>
    )
  }

  }
}

export default MemberSavingsReport; 
